export const ga = (typeof window !== 'undefined' && (window as any).ga) || (() => null)
